// Textos de la seccion de comentarios reutilizable.
//
// Estan aqui, y no dentro del componente, por dos motivos: el copy generico no
// nombra al recurso ("este contenido", no "este evento") y cada pantalla que monte
// la seccion puede reemplazar SOLO las llaves que necesite mediante la prop
// `textos`, sin tener que repetir el diccionario completo.
//
// El modulo de eventos hoy tiene su propia copia con el mismo formato
// (`EventCommentsSection`); cuando esa pantalla adopte este componente, sus textos
// entran tal cual por esa prop y ese diccionario desaparece.

export const buildCommentsTexts = ({ maxCaracteres, maxImagenes }) => ({
  es: {
    title: "Comentarios",
    placeholder: "Escribe un comentario...",
    attach: "Adjuntar imagen",
    quitarImagen: "Quitar imagen",
    submit: "Comentar",
    enviando: "Publicando...",
    exito: "Comentario publicado",
    errorVacio: "Escribe algo o adjunta una imagen para comentar",
    errorLargo: `El comentario no puede exceder ${maxCaracteres} caracteres`,
    errorEnvio: "No se pudo publicar el comentario. Intenta de nuevo.",
    errorFormato: "Solo se permiten imágenes JPG, PNG y WebP",
    errorTamano: "La imagen no debe superar 5 MB",
    errorCantidad: `Máximo ${maxImagenes} imágenes por comentario`,
    emptyTitle: "Sé el primero en comentar",
    emptyText: "Todavía no hay comentarios.",
    autorFallback: "Usuario",
    cargando: "Cargando comentarios...",
    errorListado: "No se pudieron cargar los comentarios.",
    reintentar: "Reintentar",
    anterior: "Anterior",
    siguiente: "Siguiente",
    pagina: "Pagina",
    de: "de",
    editado: "Comentario actualizado",
    errorEditar: "No se pudo actualizar el comentario.",
    eliminado: "Comentario eliminado",
    removido: "Comentario removido",
    errorEliminar: "No se pudo eliminar el comentario.",
    confirmarTitulo: "¿Eliminar este comentario?",
    confirmarPropio: "Esta acción no se puede deshacer.",
    confirmarModeracion:
      "Vas a eliminar el comentario de otra persona como moderador. Se le notificará que su comentario fue removido.",
    motivoEtiqueta: "Motivo (opcional)",
    motivoPlaceholder: "Por qué lo estás removiendo",
    confirmar: "Eliminar",
    cancelar: "Cancelar",
    errorReaccion: "No se pudo guardar tu reacción.",
    // Los que consume la tarjeta de comentario.
    meGusta: "Me gusta",
    acciones: "Acciones del comentario",
    editar: "Editar",
    eliminar: "Eliminar",
    guardar: "Guardar",
    editando: "Editando comentario",
    marcaEditado: "editado",
    reacciones: "Reacciones",
  },
  en: {
    title: "Comments",
    placeholder: "Write a comment...",
    attach: "Attach image",
    quitarImagen: "Remove image",
    submit: "Comment",
    enviando: "Publishing...",
    exito: "Comment published",
    errorVacio: "Write something or attach an image to comment",
    errorLargo: `The comment cannot exceed ${maxCaracteres} characters`,
    errorEnvio: "The comment could not be published. Please try again.",
    errorFormato: "Only JPG, PNG and WebP images are allowed",
    errorTamano: "The image must not exceed 5 MB",
    errorCantidad: `Maximum ${maxImagenes} images per comment`,
    emptyTitle: "Be the first to comment",
    emptyText: "There are no comments yet.",
    autorFallback: "User",
    cargando: "Loading comments...",
    errorListado: "The comments could not be loaded.",
    reintentar: "Retry",
    anterior: "Previous",
    siguiente: "Next",
    pagina: "Page",
    de: "of",
    editado: "Comment updated",
    errorEditar: "The comment could not be updated.",
    eliminado: "Comment deleted",
    removido: "Comment removed",
    errorEliminar: "The comment could not be deleted.",
    confirmarTitulo: "Delete this comment?",
    confirmarPropio: "This action cannot be undone.",
    confirmarModeracion:
      "You are about to delete someone else's comment as a moderator. They will be notified that their comment was removed.",
    motivoEtiqueta: "Reason (optional)",
    motivoPlaceholder: "Why you are removing it",
    confirmar: "Delete",
    cancelar: "Cancel",
    errorReaccion: "Your reaction could not be saved.",
    meGusta: "Like",
    acciones: "Comment actions",
    editar: "Edit",
    eliminar: "Delete",
    guardar: "Save",
    editando: "Editing comment",
    marcaEditado: "edited",
    reacciones: "Reactions",
  },
});

// El idioma sale del `LangContext`, que guarda cadenas como "es", "es-MX" o "en".
// Cualquier cosa que no empiece por "es" cae en ingles, igual que en el resto de
// la aplicacion.
export const esIdiomaEspanol = (lang) => Boolean(lang?.toLowerCase?.().startsWith("es"));

// Los `overrides` pisan llave por llave: quien monta la seccion cambia el vacio o
// el titulo sin quedarse sin el resto del diccionario.
export const resolveCommentsTexts = ({
  lang,
  overrides = {},
  maxCaracteres,
  maxImagenes,
} = {}) => {
  const base = buildCommentsTexts({ maxCaracteres, maxImagenes });
  const idioma = esIdiomaEspanol(lang) ? "es" : "en";
  // Se acepta tanto `{ es: {...}, en: {...} }` como un objeto plano ya resuelto,
  // porque una pantalla con un solo idioma no deberia tener que anidar.
  const propios = overrides?.es || overrides?.en ? overrides[idioma] : overrides;
  return { ...base[idioma], ...(propios || {}) };
};
